import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBackgroundChangerConfig } from '@/data/landingConfig/landingBackgroundChangerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BackgroundChanger } from './schemaObject';

interface Props {}
const BackgroundChanger: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BackgroundChanger} />
			<LandingTemplate
				data={landingBackgroundChangerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAIBackground()}
			/>
		</>
	);
};

export default BackgroundChanger;
